import script from "./AmbassadorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AmbassadorCard.vue?vue&type=script&setup=true&lang=js"

import "./AmbassadorCard.vue?vue&type=style&index=0&id=48998fe0&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48998fe0"]])

export default __exports__